import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Commands } from 'src/app/data/model/device-messeges-to-send';

@Component({
  selector: 'app-payload-dialog',
  standalone: false,
  templateUrl: './payload-dialog.html',
  styleUrl: './payload-dialog.scss',
})
export class PayloadDialog implements OnInit {

  public get displayedColumns(): string[] {
    return ['name', 'payload_size', 'payload', 'payload_hex']
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: Commands[]
  ) { }

  ngOnInit(): void {
  }

}